module.exports = __webpack_public_path__ + "img/bank-bca.ba675613.png";